import { render, staticRenderFns } from "./folders-list-file-and-folder.vue?vue&type=template&id=14cfbfa4&scoped=true"
import script from "./folders-list-file-and-folder.vue?vue&type=script&lang=js"
export * from "./folders-list-file-and-folder.vue?vue&type=script&lang=js"
import style0 from "./folders-list-file-and-folder.vue?vue&type=style&index=0&id=14cfbfa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cfbfa4",
  null
  
)

export default component.exports